<div class="search-tags-content">
  <label class="core-text-field">
    <div>
        <div class="core-text-field-wrapper trailing">
            <input id="textField" (keydown.enter)="addItem(autoCompleteControl.value)" placeholder="Enter tag text to be added" [formControl]="autoCompleteControl" type="text" class="core-text-field" [matAutocomplete]="auto" />
            <app-icon *ngIf="isResultLoading" iconName="loader" class="spin"></app-icon>
            <app-icon *ngIf="!isResultLoading" iconName="addToList"></app-icon>
        </div>
    </div>

    <div class="core-help-text" *ngIf="searchTagMessage">
      <span>
          <app-icon iconName="errorFill"></app-icon>
          {{searchTagMessage}}
      </span>
  </div>
</label>
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="addItem($event.option.value)">
    <mat-option *ngFor="let option of filteredAutoCompleteOptions | async" [value]="option">
        {{option}}
    </mat-option>
</mat-autocomplete>
  
  <div class="search-tags">
    <button 
      type="button"
      *ngFor="let tag of tagList"
      tabindex="-1"
      class="chip-input"
    >
      {{ tag }}
      <app-icon iconName="roundXMark" (click)="removeTag(tag)" class="delete-icon"></app-icon>
    </button>
  </div>
</div>
